import React from 'react';
import { resetCookieConsentValue } from 'react-cookie-consent';
import './styles/CookieSettingsButton.css';

function CookieSettingsButton() {
  const handleReset = () => {
    resetCookieConsentValue('jbc-cookie-consent');
    window.location.reload();
  };

  return (
    <button
      className="cookie-settings-btn"
      onClick={handleReset}
      aria-label="Cookieindstillinger"
      title="Skift cookieindstillinger"
    >
      🍪
    </button>
  );
}

export default CookieSettingsButton;
